import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a11019a2ab6ae00143c9c69/budgetiq/src/app/sign-up-login-screen/components/AuthForm.tsx");
